/**
 * Settings row glyphs. 24x24 viewBox, drawn at 20px inside a 36x36 tile, radius 11.
 * fill="none" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round".
 * Stroke #FFF9EC on forest/sky/brown/ink tiles; #1E2B22 on sun (#F2B544) tiles.
 *
 * Row -> glyph -> tile colour
 *   Your family       house     #2E7D4F     Recovery sheet  sheet     #9A5B34
 *   Children          children  #2E7D4F     Family code     key       #9A5B34
 *   Grown-ups         grownup   #2F7FBF     Backup          download  #9A5B34
 *   Counting in       coin      #F2B544     Devices & codes phone     #2F7FBF
 *   Allowance         calendar  #F2B544     Valley on a screen screen #2F7FBF
 *   Sign out          signout   #1E2B22
 */
export const SETTINGS_ICONS = {
  sheet: '<path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/>',
  house: '<path d="M4 11 12 4l8 7v9h-5v-5h-6v5H4z"/>',
  children: '<circle cx="8" cy="9" r="2.6"/><circle cx="16" cy="9" r="2.6"/><path d="M3.5 19c.5-3 2.3-4.5 4.5-4.5s4 1.5 4.5 4.5M11.5 19c.5-3 2.3-4.5 4.5-4.5s4 1.5 4.5 4.5"/>',
  grownup: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20c.8-4 3.6-6 7-6s6.2 2 7 6"/>',
  coin: '<circle cx="12" cy="12" r="8"/><path d="M12 6.5v11M14.6 9.3c-.5-.8-1.5-1.3-2.6-1.3-1.5 0-2.6.8-2.6 2s1.1 1.6 2.6 2 2.6.8 2.6 2-1.1 2-2.6 2c-1.2 0-2.2-.5-2.7-1.4"/>',
  calendar: '<rect x="4" y="5.5" width="16" height="14.5" rx="3"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4"/>',
  key: '<circle cx="8" cy="12" r="4"/><path d="M12 12h8.5M17.5 12v3M20.5 12v2.5"/>',
  download: '<path d="M12 4v10M8 10.5l4 4 4-4"/><path d="M4.5 15v3a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-3"/>',
  phone: '<rect x="7" y="3" width="10" height="18" rx="2.5"/><path d="M11 17.5h2"/>',
  screen: '<rect x="3" y="5" width="18" height="12" rx="2.5"/><path d="M8 21h8M12 17v4"/>',
  signout: '<path d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4"/><path d="M14 8l4 4-4 4M18 12H9"/>',
} as const;
